'use client';

import { COLORS } from '@/constants';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const WelcomeBannerWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding: 40px;
  border-radius: 10px;
  background: ${COLORS['blue']};
  overflow: hidden;
  margin-bottom: 32px;
`;

export const WelcomeBannerContent = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 650px;
  position: relative;
  z-index: 1;
`;

export const WelcomeBannerIllustration = styled.div`
  position: absolute;
  right: -21px;
  top: 0;
  bottom: 0;
  width: 230px;
  pointer-events: none;

  img {
    width: 100%;
    height: 100%;
  }

  @media (max-width: 640px) {
    display: none;
  }
`;

export const WelcomeBannerButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  border-radius: 6px;
  border: none;
  background: ${COLORS['secondary/500']};
  color: ${COLORS.white};
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  width: fit-content;
  transition: background 0.15s ease;

  &:hover {
    background: ${COLORS['secondary/700']};
  }
`;

export const StatsSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const StatsSectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  padding: 6px 0;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

export const StatCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 22px;
  border-radius: 8px;
  background: ${COLORS.white};
  box-shadow: 0px 2px 4px 0px #7b63571a;
`;

export const StatCardTopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const StatIconPlaceholder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 6px;
  background: ${COLORS['primary/50']};
  color: ${COLORS['primary/600']};
  flex-shrink: 0;
`;

export const StatCardValue = styled.div`
  font-size: 34px;
  font-weight: 600;
  color: ${COLORS['primary/900']};
  line-height: 1;
`;

export const StatCardLabel = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: ${COLORS['primary/500']};
`;
